import React, { Component } from 'react';
import ImageSlider from './ImageSlider/ImageSlider';
import { styled } from 'linaria/react';

const Wrapper = styled('div')`
  width: 100%;
`;

class ProductImages extends Component {
  render() {
    const { product, customData, className, selectedVariation } = this.props;
    const images = product?.images || [];
    return (
      <Wrapper>
        <ImageSlider
          images={images}
          badges={product.badges}
          selectedVariation={selectedVariation}
          customData={customData}
          className={className}
        />
      </Wrapper>
    );
  }
}

export default ProductImages;
